export enum ReportOccurrence {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum ReportType {
  CONSUMPTION_REPORT = 'CONSUMPTION_REPORT',
  CONSUMPTION_EXPORT_REPORT = 'CONSUMPTION_EXPORT_REPORT',
  CUSTOMER_BILLING_REPORT = 'CUSTOMER_BILLING_REPORT',
  ALARM_REPORT = 'ALARM_REPORT',
  TRANSMISSION_REPORT = 'TRANSMISSION_REPORT',
  LICENSE_REPORT = 'LICENSE_REPORT',
}

// ReportSettings base interface with discriminated union
interface BaseReportSettings {
  reportType: ReportType;
}

export interface ConsumptionReportSettings extends BaseReportSettings {
  reportType: ReportType.CONSUMPTION_REPORT;
}

export interface ConsumptionExportReportSettings extends BaseReportSettings {
  reportType: ReportType.CONSUMPTION_EXPORT_REPORT;
}

export interface CustomerBillingReportSettings extends BaseReportSettings {
  reportType: ReportType.CUSTOMER_BILLING_REPORT;
}

export interface AlarmReportSettings extends BaseReportSettings {
  reportType: ReportType.ALARM_REPORT;
}

export interface TransmissionReportSettings extends BaseReportSettings {
  reportType: ReportType.TRANSMISSION_REPORT;
}

export interface LicenseReportSettings extends BaseReportSettings {
  reportType: ReportType.LICENSE_REPORT;
  isActive?: boolean;
  isValid?: boolean;
}

export type ReportSettings =
  | ConsumptionReportSettings
  | ConsumptionExportReportSettings
  | CustomerBillingReportSettings
  | AlarmReportSettings
  | TransmissionReportSettings
  | LicenseReportSettings;

export interface ReportConfigDto {
  deviceGroup: string[];
  reportName: string;
  reportOccurrence: ReportOccurrence;
  emailList: string;
  companyId: number;
  startDate: string; // ISO 8601 date-time string
  endDate: string; // ISO 8601 date-time string
  lastExecution: string; // ISO 8601 date-time string
  nextExecution: string; // ISO 8601 date-time string
  calcMin: boolean;
  calcMax: boolean;
  calcAverage: boolean;
  reportSettings: ReportSettings;
}
